import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { addWarehouseStockApi } from '../../api/endpoints';

// Initial state
const initialState = {
  status: '', // loading, success, error
  data: null,
  message: '',
};

// Async thunks for CREATE operations
export const addWarehouseStock = createAsyncThunk('addWarehouseStock', async (payload) => {
  return await addWarehouseStockApi(payload);
});

const addWarehouseStockSlice = createSlice({
  name: 'addWarehouseStock', // Unique Name
  initialState,
  reducers: {
    addWarehouseStockReset: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(addWarehouseStock.pending, (state) => {
        state.status = 'loading';
        state.data = {};
      })
      .addCase(addWarehouseStock.fulfilled, (state, action) => {
        const { message = '', data = {}, payload = null } = action.payload;
        state.status = 'success';
        state.message = message;
        state.data = data || payload;
      })
      .addCase(addWarehouseStock.rejected, (state, action) => {
        const { message } = action.error || {};
        state.status = 'error';
        state.message = message;
      });
  },
});
export const { addWarehouseStockReset } = addWarehouseStockSlice.actions;

export default addWarehouseStockSlice.reducer;
